import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import { COLOR_PRIMARY_DARK } from 'src/const';

import GoogleMapComponent from './GoogleMapComponent';
import DataTable from './DataTable';

import {activeMarketsArrayType} from "./ActiveMarkersConst";

const AuthorizedView = ({ markets }: { markets: activeMarketsArrayType[] }) => {
  const [viewMode, setViewMode] = useState<'map' | 'list'>('map');

  const handleSwitchChange = e => {
    if (e.target.checked) {
      setViewMode('map');
    } else {
      setViewMode('list');
    }
  };

  return (
    <Grid container xs={12} justifyContent="center" alignItems="center" sx={{ marginTop: '40px' }}>
      <div
        style={{
          background: COLOR_PRIMARY_DARK,
          color: '#fff',
          padding: '10px 20px',
          width: '50%',
          borderRadius: '4px',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" style={{ fontWeight: 900 }}>
          Active Subscribed Markets
        </Typography>
      </div>

      <br />

      <Grid item xs={12} style={{ marginTop: '40px', marginBottom: '40px' }}>
        <div style={{ width: '100px', marginLeft: 'auto', marginRight: 'auto' }}>
          <Stack direction="row" alignItems="center">
            <Typography style={{ fontWeight: 500 }}>List</Typography>
            <Switch defaultChecked onChange={handleSwitchChange} />
            <Typography style={{ fontWeight: 500 }}>Map</Typography>
          </Stack>
        </div>
      </Grid>

      <Grid item xs={10}>
        <div
          style={{
            height: '400px',
            width: '100%',
            padding: '10px',
            boxShadow: '0 0 10px #ccc',
            marginBottom: '40px',
            background: '#fff',
          }}
        >
          {viewMode === 'map' ? (
            <GoogleMapComponent markets={markets} />
          ) : (
            <DataTable markets={markets} />
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default AuthorizedView;
